import React, { useState } from 'react';
import Icon from '../AppIcon';


const AdminToolbar = ({ currentEntity = 'users' }) => {
  const [activeFilters, setActiveFilters] = useState([]);

  const entityTools = {
    users: [
      { id: 'export', label: { en: 'Export', ar: 'تصدير' }, icon: 'Download' },
      { id: 'bulk', label: { en: 'Bulk Actions', ar: 'إجراءات جماعية' }, icon: 'CheckSquare' },
      { id: 'filter', label: { en: 'Filter', ar: 'تصفية' }, icon: 'Filter' },
      { id: 'refresh', label: { en: 'Refresh', ar: 'تحديث' }, icon: 'RefreshCw' }
    ],
    workshops: [
      { id: 'export', label: { en: 'Export', ar: 'تصدير' }, icon: 'Download' },
      { id: 'map', label: { en: 'Map View', ar: 'عرض الخريطة' }, icon: 'Map' },
      { id: 'filter', label: { en: 'Filter', ar: 'تصفية' }, icon: 'Filter' },
      { id: 'refresh', label: { en: 'Refresh', ar: 'تحديث' }, icon: 'RefreshCw' }
    ],
    agencies: [
      { id: 'export', label: { en: 'Export', ar: 'تصدير' }, icon: 'Download' },
      { id: 'analytics', label: { en: 'Analytics', ar: 'التحليلات' }, icon: 'TrendingUp' },
      { id: 'filter', label: { en: 'Filter', ar: 'تصفية' }, icon: 'Filter' },
      { id: 'refresh', label: { en: 'Refresh', ar: 'تحديث' }, icon: 'RefreshCw' }
    ],
    emergency: [
      { id: 'export', label: { en: 'Export', ar: 'تصدير' }, icon: 'Download' },
      { id: 'availability', label: { en: 'Availability', ar: 'التوفر' }, icon: 'Clock' },
      { id: 'filter', label: { en: 'Filter', ar: 'تصفية' }, icon: 'Filter' },
      { id: 'refresh', label: { en: 'Refresh', ar: 'تحديث' }, icon: 'RefreshCw' }
    ],
    products: [
      { id: 'export', label: { en: 'Export', ar: 'تصدير' }, icon: 'Download' },
      { id: 'inventory', label: { en: 'Inventory', ar: 'المخزون' }, icon: 'Package' },
      { id: 'filter', label: { en: 'Filter', ar: 'تصفية' }, icon: 'Filter' },
      { id: 'refresh', label: { en: 'Refresh', ar: 'تحديث' }, icon: 'RefreshCw' }
    ]
  };

  const language = localStorage.getItem('language') || 'ar';
  const tools = entityTools?.[currentEntity] || entityTools?.users;

  const handleToolClick = (toolId) => {
    if (toolId === 'filter') {
      setActiveFilters(prev => prev?.includes(toolId) ? prev?.filter(f => f !== toolId) : [...prev, toolId]);
    } else if (toolId === 'export') {
      console.log('Exporting data...');
    } else if (toolId === 'refresh') {
      console.log('Refreshing data...');
    } else if (toolId === 'bulk') {
      console.log('Opening bulk actions...');
    }
  };

  return (
    <div className="admin-toolbar">
      <div className="admin-toolbar-container">
    

   
      </div>
    </div>
  );
};

export default AdminToolbar;